import { isTitlesFootnotesReadDto } from "functions/api/tlfItem/TitlesFootnotesReadDto";
import type { IMosaicTocExpanded, ITocActionUpdateEntry, MosaicTocEntryDto } from "./interface";

/**
 * Applies an updated entry payload to an existing ToC entry.
 *
 * @param state - The current expanded ToC state.
 * @param action - The action containing the updated entry payload.
 * @returns The updated ToC state after the matching entry is refreshed.
 */
export const toc_updateEntry = (
  state: IMosaicTocExpanded,
  action: ITocActionUpdateEntry,
): IMosaicTocExpanded => {
  const newState: IMosaicTocExpanded = { ...state };
  const index = newState.tocItems.findIndex(
    (item) => item.id === action.update.id && isTitlesFootnotesReadDto(item),
  );

  /* istanbul ignore else -- callers only update entries that already exist in ToC state. */
  if (index > -1) {
    const current: MosaicTocEntryDto = {
      ...(newState.tocItems[index] as MosaicTocEntryDto),
    };
    current.inError = false;
    current.changed = false;
    Object.keys(action.update)
      .filter((key) => !["id", "saved", "changed", "inError"].includes(key))
      .forEach((key) => {
        if (action.update[key] !== current[key]) {
          current[key] = action.update[key];
        }
      });
    newState.tocItems = [
      ...newState.tocItems.slice(0, index),
      current,
      ...newState.tocItems.slice(index + 1),
    ];
  }
  newState.blocked = "getNewVersion";

  return newState;
};
